import { NavLink, useLocation } from "react-router";

import { Button } from "../components/Button";
import { PlusIcon } from "../components/icons";
import { companyIdFromPath, useReport } from "../features/report/ReportProvider";
import { nl } from "../i18n/nl";
import { ThemeToggle } from "./ThemeToggle";
import styles from "./TopBar.module.css";

export function TopBar({ className, title }: { className?: string; title: string }) {
  const openReport = useReport();
  const { pathname } = useLocation();
  return (
    <header className={[styles.topbar, className].filter(Boolean).join(" ")}>
      <nav aria-label={nl.nav.breadcrumb} className={styles.crumbs}>
        <span>{nl.app.breadcrumbRoot}</span>
        <span aria-hidden="true">/</span>
        <span className={styles.current} aria-current="page">
          {title}
        </span>
      </nav>
      <div className={styles.actions}>
        <ThemeToggle />
        <div role="group" aria-label={nl.nav.view} className={styles.segmented}>
          <NavLink to="/" end className={({ isActive }) => (isActive ? styles.segActive : styles.seg)}>
            {nl.nav.list}
          </NavLink>
          <NavLink to="/kaart" className={({ isActive }) => (isActive ? styles.segActive : styles.seg)}>
            {nl.nav.map}
          </NavLink>
        </div>
        <Button
          variant="primary"
          aria-keyshortcuts="N"
          onClick={() => {
            openReport(companyIdFromPath(pathname));
          }}
        >
          <PlusIcon size={14} />
          {nl.nav.newReport}
          <kbd className={styles.kbd}>N</kbd>
        </Button>
      </div>
    </header>
  );
}
